import { XLg } from "react-bootstrap-icons";

//App
import Button from "../VFX-UI/Button/Button";
import useButtonStyles from "./styles";

interface XCloseButton<T = any> {
  closeActionHandler: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const XCloseButton : React.FC<XCloseButton> = ({
  closeActionHandler,
  disabled = false,
}) => {
  const buttonsStyles = useButtonStyles();
  return (
    <Button style={buttonsStyles.xCloseButton} onClick={closeActionHandler} disabled={disabled}>
      <XLg />
    </Button>
  );
};

export default XCloseButton;
